import { intersection } from 'lodash'

import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import InfrastructuresApi from '@/services/apiServiceModules/infrastructuresApi'
const infrastructuresApi = new InfrastructuresApi()

const elementMatchesQueryParams = (element, query) => {
	// console.log('elementMatchesQueryParams', element, query)
	const queryResult = {}
	Object.keys(query).forEach((key) => {
		queryResult[key] = null
		switch (key) {
			case 'legal_entity_ids':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.entity)
				}
				break
			case 'infrastructure_object_type_ids':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.object_type)
				}
				break
			case 'infrastructure_types_ids':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.infrastructure_type)
				}
				break
			case 'clusters_ids':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.cluster)
				}
				break
			case 'infrastructure_tags_ids':
				if (query[key].length > 0) {
					queryResult[key] = intersection(query[key], element.tags).length >= 1
				}
				break
			default:
				queryResult[key] = true
		}
	})

	return Object.values(queryResult).every((value) => value === true)
}

export default class InfrastructuresDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.INFRASTRUCTURES, infrastructuresApi, {
			useCache: true,
		})
	}

	getFilteredInfrastructures(companyId, query) {
		return new Promise((resolve, reject) => {
			this.getEntities(companyId, query)
				.then((res) => {
					const possibleQueryParams = {}
					Object.keys(query ?? {}).forEach((key) => {
						if ([
							'legal_entity_ids',
							'infrastructure_object_type_ids',
							'infrastructure_types_ids',
							'clusters_ids',
							'infrastructure_tags_ids',
						].includes(key)) {
							possibleQueryParams[key] = query[key]
						}
					})
					if (Object.keys(possibleQueryParams).length > 0) {
						const filtered = res.filter((element) => {
							return elementMatchesQueryParams(element, possibleQueryParams)
						})
						return resolve(filtered)
					}
					return resolve(res)
				})
				.catch((err) => {
					reject(err)
				})
		})
	}
}
